import api from './api';

export const paymentRemindersService = {
  // Get all payment reminders
  getAll: async () => {
    const response = await api.get('/payment-reminders');
    return response.data;
  },

  // Create payment reminder
  create: async (reminderData) => {
    const response = await api.post('/payment-reminders', reminderData);
    return response.data;
  },

  // Update payment reminder
  update: async (id, reminderData) => {
    const response = await api.put(`/payment-reminders/${id}`, reminderData);
    return response.data;
  },

  // Delete payment reminder
  delete: async (id) => {
    const response = await api.delete(`/payment-reminders/${id}`);
    return response.data;
  },

  // Send reminder immediately
  sendNow: async (id) => {
    const response = await api.post(`/payment-reminders/${id}/send`);
    return response.data;
  }
};
